/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_GoodInputs */

const en_fit_good = /** @type {(inputs: Fit_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good fit`)
};

const de_fit_good = /** @type {(inputs: Fit_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gute Passung`)
};

/**
* | output |
* | --- |
* | "Good fit" |
*
* @param {Fit_GoodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fit_good = /** @type {((inputs?: Fit_GoodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_GoodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fit_good(inputs)
	return en_fit_good(inputs)
});